import { render, staticRenderFns } from "./PopupButtonClose.vue?vue&type=template&id=2148c99e&scoped=true"
import script from "./PopupButtonClose.vue?vue&type=script&lang=js"
export * from "./PopupButtonClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148c99e",
  null
  
)

export default component.exports